import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { atom, useAtomValue } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';

import { SegmentPage } from '../../../misc/segment/segment-page';
import { copyTradingSettingsBunja } from './state';

export const CopyTradingCopyModalSegmentView = () => {
  const { nicknameAtom } = useBunja(copyTradingCopyModalSegmentBunja);
  const nickname = useAtomValue(nicknameAtom);
  if (nickname) return <SegmentPage name='copytrading_copy_modal_visit' context={{ master_nickname: nickname }} />;
};

export const copyTradingCopyModalSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { portfolioAtom } = bunja.use(copyTradingSettingsBunja);
  const nicknameAtom = atom((get) => get(portfolioAtom)?.nickname);
  function trackCopyTradingCopyConfirmClick() {
    const nickname = store.get(nicknameAtom);
    if (!nickname) return;
    segment.track('copytrading_copy_modal_click_confirm', {
      master_nickname: nickname,
    });
  }
  return { nicknameAtom, trackCopyTradingCopyConfirmClick };
});
copyTradingCopyModalSegmentBunja.debugLabel = 'copyTradingCopyModalSegmentBunja';
